import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core'
import { CommonModule } from '@angular/common'
import { I18nConfig, I18nModule, provideConfig } from '@spartacus/core'
import { SsoRedirectComponent } from './sso-redirect/sso-redirect.component'
import { MyProfileModule } from './my-profile/my-profile.module'
import { ChangeCustAccountModule } from './change-cust-account/change-cust-account.module'
import { CustomerAccountModule } from './customer-account/customer-account.module'
import { AccessDeniedComponent } from './access-denied/access-denied.component'
import { IdleSessionTimeoutDialogComponent } from './idle-timeout-dialog/idle-timeout-dialog'
import { DIALOG_TYPE } from '@spartacus/storefront'
import { environment } from '../../../environments/environment'
import { VS_LAUNCH_CALLER } from '../config/dialog.config'

@NgModule({
  declarations: [
    SsoRedirectComponent,
    IdleSessionTimeoutDialogComponent,
    AccessDeniedComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    MyProfileModule,
    ChangeCustAccountModule,
    CustomerAccountModule,
  ],
  providers: [
    provideConfig(<I18nConfig>{
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + 'assets/i18n-assets/{{lng}}/{{ns}}.json',
          // loadPath: '/_ui/responsive/common/vs-spartacus/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          userData: ['userData'],
        },
      },
    }),
    provideConfig({
      launch: {
        [VS_LAUNCH_CALLER.IDLE_TIMEOUT]: {
          inlineRoot: true,
          component: IdleSessionTimeoutDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class UserModule {}
